import { createTestId } from 'aem-libs-tests/src/utility/createTestId'
import { inputTestIds } from 'aem-libs-tests/src/utility/inputTestIds'

import { APP_NAME } from '../constants'

const loanInputBase = createTestId(APP_NAME, 'amount-type-input')
const monthlyPaymentBase = createTestId(APP_NAME, 'monthly-payment-type-input')
const extraLoanBase = createTestId(APP_NAME, 'extra-loan-type-input')
const resultSectionBase = createTestId(APP_NAME, 'result-section')
const outOfLimitResultBase = createTestId(APP_NAME, 'out-of-limit-result')
const loanDurationBase = createTestId(APP_NAME, 'duration-type-input')

export const testIds = {
  loanInputBase,
  loanInput: inputTestIds(loanInputBase),
  monthlyPaymentBase,
  monthlyPayment: inputTestIds(monthlyPaymentBase),
  extraLoanBase,
  extraLoan: inputTestIds(extraLoanBase),
  resultSectionBase,
  resultSectionContainer: createTestId(resultSectionBase, 'container'),
  outOfLimitResultContainer: createTestId(outOfLimitResultBase, 'container'),
  loanDurationBase,
  loanDuration: inputTestIds(loanDurationBase),
  resultMonthly: `${APP_NAME}--resultMonthly`,
  resultDuration: `${APP_NAME}--resultDuration`,
  resultMonthlyPaymentsSave: createTestId(APP_NAME, 'result-monthly-payments-save'),
  resultInterestRate: createTestId(APP_NAME, 'result-interest-rate'),
  resultRpsn: createTestId(APP_NAME, 'result-rpsn'),
  resultCta: createTestId(APP_NAME, 'result-cta'),
  outOfLimitResultCta: createTestId(APP_NAME, 'out-of-limit-result-cta')
}
